import {call, put, takeLatest} from 'redux-saga/effects';

import {
    IFeed,
    FeedType,
} from "./types";
import * as api from "../../firebase/api";
import {deleteFeedAsyncActions, loadFeedsAsyncActions, saveFeedAsyncActions, setActiveFeedAction} from "./actions";
import {feedCollectionKey} from "../../firebase/api";
import {IdObjectsWithId} from "../../utils";

function* initFeedSaga(action: ReturnType<typeof loadFeedsAsyncActions.request>) {
    const data: IdObjectsWithId<IFeed> = yield call(api.fetchCollection, feedCollectionKey);

    yield put(loadFeedsAsyncActions.success({
        feeds: data, feedType: FeedType.SAMPLE
    }))
}

function* saveFeedSaga(action: ReturnType<typeof saveFeedAsyncActions.request>) {
    if (action.payload.feedType == FeedType.SAMPLE) {
        // @ts-ignore
        const data = yield call(api.saveDocToCollection, feedCollectionKey, action.payload.feed);
        yield put(saveFeedAsyncActions.success({
            feed: data
        }))
        yield put(setActiveFeedAction({
            feed: data
        }))
    }
}

function* deleteFeedSaga(action: ReturnType<typeof deleteFeedAsyncActions.request>) {
    // @ts-ignore
    const data = yield call(api.deleteDocById, feedCollectionKey, action.payload.id);
    yield put(deleteFeedAsyncActions.success({
        id: action.payload.id
    }))
}

function* feedActionWatcher() {
    yield takeLatest(loadFeedsAsyncActions.request, initFeedSaga)
    yield takeLatest(saveFeedAsyncActions.request, saveFeedSaga)
    yield takeLatest(deleteFeedAsyncActions.request, deleteFeedSaga)
}

export default feedActionWatcher;